import React from "react";
import { assetsPath } from "../../../../../utils";

export default ({ currentLang, selectedType, selectedBuilding }) => {
  const BG = `${assetsPath(
    "laguna-beachside"
  )}/images/site-plan/${currentLang}/1.jpg`;
  const shouldDisplayByType = (type) => {
    return selectedType === type || selectedType === "all"
      ? "opacity-in"
      : "opacity-out";
  };
  const shouldDisplay = (build, type) => {
    return (selectedType === type || selectedType === "all") &&
      (selectedBuilding === build || selectedBuilding === "all")
      ? "opacity-in"
      : "opacity-out";
  };

  // const shouldDisplay = (build, type) => {
  //   return (selectedType === type || selectedType === "all") &&
  //     selectedBuilding === build
  //     ? "opacity-in"
  //     : "opacity-out";
  // };

  const fill = "#231f20";
  const opacity = 1;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 841.89 595.28"
      data-name="Layer 1"
      className="site-plan-svg"
    >
      <g id="map">
        <image xlinkHref={BG} height="100%" width="100%" />
      </g>
      <g id="floorplan">
        <g className="building-a">
          <g id="2-bed" data-name="1_2" className={shouldDisplay("a", "2-bed")}>
            <rect
              x="609.31"
              y="286.8"
              width="31.13"
              height="27.39"
              transform="translate(18.09 -35.02) rotate(3.26)"
              fill="#231f20"
              opacity="0.9"
            />
            <rect
              x="693.14"
              y="285.49"
              width="31.79"
              height="27.18"
              transform="translate(18.14 -39.81) rotate(3.26)"
              fill="#231f20"
              opacity="0.9"
            />
          </g>
          <g id="3-bed" data-name="1_3" className={shouldDisplay("a", "3-bed")}>
            <rect
              x="641.3"
              y="282.86"
              width="41.1"
              height="27.46"
              transform="translate(18.4 -38.04) rotate(3.34)"
              fill="#231f20"
              opacity="0.9"
            />
          </g>
        </g>
        <g className="building-b">
          <g id="2-bed" data-name="2_2" className={shouldDisplay("b", "2-bed")}>
            <rect
              x="355.64"
              y="232.74"
              width="31.17"
              height="27.14"
              transform="translate(37.17 -48.45) rotate(7.86)"
              fill="#231f20"
              opacity="0.9"
            />
            <rect
              x="477.33"
              y="259.51"
              width="31.17"
              height="27.14"
              transform="translate(72.55 -102.19) rotate(12.77)"
              fill="#231f20"
              opacity="0.9"
            />
            <rect
              x="518.16"
              y="268.69"
              width="31.17"
              height="27.14"
              transform="translate(75.59 -110.99) rotate(12.77)"
              fill="#231f20"
              opacity="0.9"
            />
          </g>
          <g id="3-bed" data-name="2_3" className={shouldDisplay("b", "3-bed")}>
            <rect
              x="386.83"
              y="240.25"
              width="41.1"
              height="27.53"
              transform="translate(39.37 -54.29) rotate(8.01)"
              fill="#231f20"
              opacity="0.9"
            />
            <rect
              x="549.96"
              y="273.5"
              width="41.1"
              height="27.25"
              transform="translate(77.35 -118.72) rotate(12.74)"
              fill="#231f20"
              opacity="0.9"
            />
            <rect
              x="437.27"
              y="248.05"
              width="41.1"
              height="27.25"
              transform="translate(68.96 -94.5) rotate(12.74)"
              fill="#231f20"
              opacity="0.9"
            />
          </g>
        </g>
        <g className="building-c">
          <g id="2-bed" data-name="3_2" className={shouldDisplay("c", "2-bed")}>
            <rect
              x="75.55"
              y="229.21"
              width="31.31"
              height="27.44"
              fill="#231f20"
              opacity="0.9"
            />
            <rect
              x="205.86"
              y="229.21"
              width="31.31"
              height="27.44"
              fill="#231f20"
              opacity="0.9"
            />
          </g>
          <g id="3-bed" data-name="3_3" className={shouldDisplay("c", "3-bed")}>
            <rect
              x="107.66"
              y="232.09"
              width="40.95"
              height="27.32"
              fill="#231f20"
              opacity="0.9"
            />
            <rect
              x="156.48"
              y="232.09"
              width="41.74"
              height="27.32"
              fill="#231f20"
              opacity="0.9"
            />
            <rect
              x="237.96"
              y="232.09"
              width="41.07"
              height="27.32"
              fill="#231f20"
              opacity="0.9"
            />
            <rect
              x="286.89"
              y="232.09"
              width="41.82"
              height="27.32"
              fill="#231f20"
              opacity="0.9"
            />
          </g>
        </g>
        <g className="building-d">
          <g id="1-bed" data-name="4_1" className={shouldDisplay("d", "1-bed")}>
            <rect
              id="_4106"
              data-name="4106"
              x="405.9"
              y="320.5"
              width="23.4"
              height="21.27"
              fill="#231f20"
              opacity="0.9"
            />
            <rect
              id="_4107"
              data-name="4107"
              x="405.9"
              y="341.7"
              width="23.4"
              height="21.97"
              fill="#231f20"
              opacity="0.9"
            />
            <rect
              id="_4108"
              data-name="4108"
              x="405.9"
              y="428.5"
              width="23.1"
              height="21.3"
              fill="#231f20"
              opacity="0.9"
            />
            <polygon
              id="_4109"
              data-name="4109"
              points="429 449.8 405.9 449.8 405.9 471 428.8 471 429 449.8"
              fill="#231f20"
              opacity="0.9"
            />
            <rect
              id="_4110"
              data-name="4110"
              x="405.9"
              y="471"
              width="22.9"
              height="21.94"
              fill="#231f20"
              opacity="0.9"
            />
          </g>
          <g id="2-bed" data-name="4_2" className={shouldDisplay("d", "2-bed")}>
            <polygon
              id="_4101"
              data-name="4101"
              points="460.9 484.5 433.6 484.5 433.6 452.5 461 452.5 460.9 484.5"
              fill="#231f20"
              opacity="0.9"
            />
            <polygon
              id="_4102"
              data-name="4102"
              points="464.4 421.3 464.4 453.3 436.8 453.3 436.8 421.3 464.4 421.3"
              fill="#231f20"
              opacity="0.9"
            />
            <polygon
              id="_4103"
              data-name="4103"
              points="433.5 422.1 433.5 390.9 461 390.9 461 422.1 433.5 422.1"
              fill="#231f20"
              opacity="0.9"
            />
            <polygon
              id="_4104"
              data-name="4104"
              points="437 359 464.4 359 464.4 391 436.8 391 437 359"
              fill="#231f20"
              opacity="0.9"
            />
            <polygon
              id="_4105"
              data-name="4105"
              points="433.5 327.8 461 327.8 461 359.7 433.5 359.7 433.5 327.8"
              fill="#231f20"
              opacity="0.9"
            />
          </g>
        </g>
      </g>
    </svg>
  );
};



// WEBPACK FOOTER //
// ./src/data/LagunaBeachside/sitePlan/svg/floor/1.js